import { Button, FormHelperText, Stack, Typography } from '@mui/material';

type DayOfWeekOption<TValue> = {
  value: TValue;
  label: string;
};

type DayOfWeekSelectProps<TValue> = {
  onChange: (selectedDays: TValue[]) => void;
  options: Array<DayOfWeekOption<TValue>>;
  selectedDays: TValue[];
  errorMessage?: string;
  disabled?: boolean;
};

export function DayOfWeekSelect<TValue>(props: DayOfWeekSelectProps<TValue>) {
  const { errorMessage, onChange, options, selectedDays, disabled = false } = props;
  const handleDayClick = (value: TValue) => {
    if (disabled) return;

    const isSelected = selectedDays.includes(value);
    if (isSelected) {
      onChange(selectedDays.filter((v) => v !== value));
    } else {
      onChange(selectedDays.length ? [...selectedDays, value] : [value]);
    }
  };

  return (
    <Stack gap={0.5}>
      <Stack direction="row" gap={1}>
        {options.map(({ label, value }) => {
          const selected = selectedDays.includes(value);
          return (
            <Button
              key={String(value)}
              variant={selected ? 'contained' : 'outlined'}
              disabled={disabled}
              sx={(theme) => ({
                justifyItems: 'flex-start',
                minWidth: 0,
                padding: theme.spacing(1.25, 1.75),
                width: 44,
                height: 44,
              })}
              onClick={() => handleDayClick(value)}
            >
              <Typography color={selected ? 'white' : 'primary.main'} variant="h3">
                {label}
              </Typography>
            </Button>
          );
        })}
      </Stack>
      {errorMessage && (
        <FormHelperText>
          <Typography color="error.main" variant="body2">
            {errorMessage}
          </Typography>
        </FormHelperText>
      )}
    </Stack>
  );
}
